<div
  class="px-px-24 py-px-1"
  style="background: #f3f8fa; width: calc(100vw - 320px)"
  [formGroup]="formFilter"
>
  <div class="d-flex align-items-center justify-content-between mt-3">
    <div class="d-flex align-items-center">
      <div class="me-4 inner-add-on left-add-on my-3">
        <input
          type="search"
          class="form-control w-px-335"
          formControlName="missionTitle"
          placeholder="Recherche par référence"
        />
        <svg-icon
          class="inner-icon left"
          svgClass="placeholder-icon"
          src="/assets/icons/search-grey.svg"
        ></svg-icon>
      </div>
      <div>
        <mat-form-field
          appearance="outline"
          class="d-flex align-items-center w-px-266"
        >
          <mat-label class="fs-16 fw-6"
            ><svg-icon src="/assets/icons/filter.svg"></svg-icon> Statut
            mission</mat-label
          >
          <mat-select multiple formControlName="statusOfCandidatOnMission">
            @for (item of filterListDone; track item) {
            <mat-option [value]="item?.value">
              {{ item?.label }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="ms-3">
        <app-custom-datepicker
          [parentForm]="formFilter"
          controlName="activeOnDate"
          placeholder="Filtrer par date"
          innerClass="date-filter-field"
          [readonly]="true"
          [clearable]="true"
          [required]="false"
        ></app-custom-datepicker>
      </div>
    </div>
  </div>

  <div
    class="card-container p-px-8 quick-filter-etablissements"
    *ngIf="siteList.length"
  >
    @for (item of siteList; track item.id) {
    <app-filter-tag
      [text]="item.name"
      bgColor="white"
      color="white"
      [chipSelected]="addressId === item.id"
      (handleClick)="toggleSelectSite($event, item)"
    ></app-filter-tag>
    }
  </div>
  <!--                <div *ngIf="isLoading" class="loader-overlay">-->
  <!--                  <app-loader></app-loader>-->
  <!--                </div>-->
  <app-data-table
    [isLoading]="isLoading"
    [dataSource]="missionList"
    [columns]="customColumns"
    (onFullRowClick)="handleRowClick($event)"
    [hasRowAction]="true"
    [showSideBar]="true"
    [component]="component"
    [totalItems]="totalItems"
    (nextPage)="pagination($event)"
    [pageSize]="size"
  ></app-data-table>
</div>
